require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./yamhill-county-smart-sentencing-initiative.json") })
        }
      }, "path---yamhill-county-smart-sentencing-initiative");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---yamhill-county-smart-sentencing-initiative!./.cache/json/yamhill-county-smart-sentencing-initiative.json
// module id = 1069
// module chunks = 231608221292675